import { z } from 'zod';
import { uuidSchema } from './common';
import { REVIEW_ASPECT_TAG_CODES } from '../review-aspects';

/**
 * Multipart fields parsed from POST /orders/:id/items/:orderItemId/review.
 * Photos arrive as file parts (handled separately); these are the text/numeric
 * fields validated from the form. `aspectTags` arrives as a JSON-encoded array
 * of tag codes (a single text field is easiest to carry over multipart).
 */
export const submitReviewSchema = z.object({
  rating: z.coerce.number().int().min(1).max(5),
  comment: z.string().max(2000).optional(),
  aspectTags: z
    .preprocess(
      (v) => {
        if (typeof v !== 'string' || v.trim() === '') return undefined;
        try {
          return JSON.parse(v);
        } catch {
          return v
            .split(',')
            .map((s) => s.trim())
            .filter(Boolean);
        }
      },
      z
        .array(z.enum(REVIEW_ASPECT_TAG_CODES as [string, ...string[]]))
        .max(REVIEW_ASPECT_TAG_CODES.length),
    )
    .optional(),
});

export const reviewResponseSchema = z.object({
  id: uuidSchema,
  orderItemId: uuidSchema,
  productId: uuidSchema,
  userId: uuidSchema,
  rating: z.number().int().min(1).max(5),
  comment: z.string().nullable(),
  photoR2Key: z.string().nullable(),
  photoR2Keys: z.array(z.string()).nullable(),
  aspectTags: z.array(z.string()).nullable(),
  createdAt: z.coerce.date(),
});
